import { UserId } from '@business/entities/account';
import { InvoiceDiscountData } from '@modules/common/InvoiceDiscount';
import { ContactId } from '../contact';

export enum StripeSubscriptionStatus {
  active = 'active',
  trialing = 'trialing',
  past_due = 'past_due',
  unpaid = 'unpaid',
  canceled = 'canceled',
  incomplete = 'incomplete',
  incomplete_expired = 'incomplete_expired',
}

export enum SubscriptionInterval {
  monthly = 'monthly',
  quarterly = 'quarterly',
  biannualy = 'bi-annually',
  yearly = 'yearly',
}

export enum LineItemObjectType {
  co = 'co',
  vendorInvoice = 'vendor-invoice',
  discount = 'discount', // a Work Order discount placed on the invoice (negative amount)
}

export interface LineItem {
  id: number;
  objectType: LineItemObjectType;
  objectId: string;
  serviceId: string;
  productId: string;
  classId: string;
  service: string;
  qty: number;
  unitPrice: number;
  description: string;
  title?: string;
  saleRep: UserId;
  saleRep2: UserId;
  taxable: boolean;
  vendorId: string;
  productSku: string;
  unitOfMeasure: string;
  thumbnail: string;
  isDiscount?: boolean;
}

export type SubscriptionId = string;
export interface SubscriptionResponse extends SubscriptionMulticurencyResponse {
  id: SubscriptionId;
  name: string;
  title: string;
  invoiceId: number;
  amount: number;
  cycle: SubscriptionInterval;
  startDate: number;
  invoiceDate: number;
  isCanceled: boolean;
  isOverdue: boolean;
  canceledAt: number | null;
  nextDate: number | null;
  paymentMethodId?: string;
  contactEmail?: string;
  contactId: ContactId;
  saleRepId?: UserId;
  canResend: boolean;
  lineItems: LineItem[];
  memo: string;
  message: string;
  discount: InvoiceDiscountData;
  isStripe: boolean;
  stripeStatus: StripeSubscriptionStatus;
  hasStarted: boolean;
}
export interface SubscriptionMulticurencyResponse {
  subAmountDefault: number;
}
